import { LabelDurationValueInputT } from "../../../../../util/duration/types"

export const silenceDurationUnitOptions: LabelDurationValueInputT[] = [
    { label: "days", value: "d" },
    { label: "hrs", value: "h" },
    { label: "mins", value: "m" },
]
